module.exports = __webpack_public_path__ + "img/logo-login-portaltelemedicina-white.ae7b8ae3.png";